module.exports = __webpack_public_path__ + "img/MBOMImpactSand-min.2bed07d9.png";